import styled from 'styled-components';
import { MAX_WRAPPER_SIZE, FRAME_MOBILE_SIZE } from '../../../../settings';

export default {
    BPFrame: styled.div.attrs({ className: 'billing-page-frame' })`
        width: 100%;
        height: auto;
    `,
    MainContainer: styled.div.attrs({ className: 'main-container' })`
        width: 100%;
        overflow: hidden;
        @media (min-height: 1500px) {
            min-height: 100vh;
        }
    `,
    MainBox: styled.div.attrs({ className: 'main-box' })`
        max-width: ${MAX_WRAPPER_SIZE};
        min-width: 280px;
        padding-bottom: 55px;
        margin: 0 auto ${({ isStatus, extraMarginBot }) => isStatus ? 0 : extraMarginBot ? '50px' : '30px'};
        display: grid;
        align-items: flex-start;
        grid-template-areas: 'content'
                        'frame';
        grid-template-columns: 1fr;
        @media (min-width: 800px) {
            padding-left: 8px;
            padding-right: 8px;
            padding-bottom: 150px;
            grid-template-columns: calc(55% - 25px) calc(45% - 25px);
            grid-column-gap: 50px;
            grid-template-areas: 'frame content';
        }
        @media (min-width: 1200px) {
              padding-bottom: 126px;

        }
        @media (min-width: 900px) and (min-height: 1500px) {
            height: calc(100% - 526px);

        }
    `,
    MainHeaderContainer: styled.header.attrs({ className: 'main-header' })`
        display: flex;
        max-width: ${MAX_WRAPPER_SIZE};
        padding-left: 8px;
        padding-right: 8px;
        min-width: 320px;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        flex-direction: column;

        margin-bottom: 38px;
        align-items: center;
        flex-wrap: wrap;
        box-sizing: border-box;

        @media (min-width: 600px) {
            justify-content: space-between;
            flex-direction: row;
            padding: 43px 8px 35px;
            margin-bottom: 0;
        }
        @media (min-width: 700px) {
            padding-top: 86px;
            padding-bottom: 70px;
        }
        @media (min-width: 1220px) {
            padding-left: 8px;
            padding-right: 8px;
        }
    `,
    MainHeader: styled.h1.attrs({ className: 'main-h1' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 18px;
        line-height: 110%;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        order: 2;
        color: #1A1A1A;
        font-weight: 400;
        text-align: center;
        margin-top: 0;
        margin-bottom: 0;
        padding: 0 24px;

        @media (min-width: 600px) {
            width: initial;
            text-align: initial;
            order: 1;
            padding: 0;
            margin-bottom: 0;
        }

        @media (min-width: 700px) {
             font-size: 40px;
        }
    `,
    MainLogo: styled.a.attrs({ className: 'main-logo' })`
        width: 100%;
        height: auto;
        order: 1;
        justify-self: flex-start;
        margin-bottom: 33px;
        padding: 27px 24px 31px;
        position: relative;
        box-sizing: border-box;
        &:before{
          content: '';
          position: absolute;
          bottom:0;
          left: 0;
          width: 100%;
          background: #B9C0C2;
          opacity: 0.5;
          height: 1px;
        }
        @media (min-width: 600px) {
            width: max-content;
            order: 2;
            padding: 0;
            margin-bottom: 0;

            &:before{
              display: none;
            }
        }
    `,
    LogoImage: styled.img.attrs({ className: 'logo' })`
    `,
    CheckboxContainer: styled.div.attrs({ className: 'checkbox-container' })`
        padding-top: 10px;
        padding-bottom: 10px;
        position: relative;
    `,
    CheckboxWrapper: styled.div.attrs({ className: 'checkbox-wrapper' })`
        display: flex;
        flex-direction: column;
        margin: 0 24px;

        @media (max-width: 320px) {
            width: 94%;
        }

        @media (min-width: 600px){
          margin: 0 8px;
        }

        @media (min-width: 1200px) {
            margin: 0;
        }
    `,
    FrameLocker: styled.div.attrs({ className: 'frame-locker' })`
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(255,255,255,0.5);
        z-index: 200;
    `,
    FrameWrapper: styled.div.attrs({ className: 'frame-wrapper-div' })`
        width: 100%;
        margin: 0;
        height: 100%;
        grid-area: frame;
        position: relative;

        & iframe:not(.gpay-card-info-iframe) {
            position: relative;
            top: 0;
            left: 0;
            width: 100%;
            height: 595px;
        }
    `,
    ContentWrapper: styled.div.attrs({ className: 'contentWrapper' })`
        position: relative;
        border-bottom: 1px solid #B9C0C2;
        padding-bottom: 56px;
        grid-area: content;
        &:before{
            content: '';
            display: block;
            background: #B9C0C2;
            position: absolute;
            height: 1px;
            width: 100%;
            top: 0;
            left: 100%;
        }
        &:after{
            content: '';
            display: block;
            background: #B9C0C2;
            position: absolute;
            height: 1px;
            width: 100%;
            bottom: -1px;
            left: 100%;
        }
    `,
    PayButtonContainer: styled.div.attrs({ className: 'pay-buttons__container' })`
        display: flex;
        align-items: flex-start;
        padding-left: 8px;
        padding-right: 8px;
        margin: 20px 0;
        justify-content: center;
        @media(min-width: ${FRAME_MOBILE_SIZE.xl}){
            max-width: fit-content;
            margin-top: 0;
            .googlepay__container{
                margin-left: 10px;
            }

        }
        @media(min-width: ${FRAME_MOBILE_SIZE.xxl}){
            .googlepay__container{
                margin-left: 24px;
            }
        }
        @media(min-width: 721px) and (max-width: 799px){
            max-width: fit-content;
            .googlepay__container{
                margin-left: 10%;
            }
        }
        .apple{
            display: flex;
            align-items: center;
            justify-content: center;
            button{
                border-radius: 25px;
                height: 50px;
                width: 330px !important;
                @media(min-width: ${FRAME_MOBILE_SIZE.xl}){
                    margin-left: 2vw;
                    width: 272px !important;
                }
                @media(min-width: 721px) and (max-width: 799px){
                    margin-left: 4vw;
                    width: 260px !important;
                }
                @media(max-width: 720px){
                    margin-top: 20px;
                }
            }
        }
        @media(max-width: 800px){
            justify-content: center;
            align-items: center;
            .apple{
                margin-right: 0;
            }
            & > div{
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    `,
    StatusContainer: styled.div.attrs({ className: 'status__container' })`
        grid-area: frame;
        margin-top: 20px;

        @media(max-width: 800px){
            margin-top: 50px;
            padding-left: 8px;
            padding-right: 8px;
            margin-bottom: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            grid-row-gap: 20px;
        }
    `,
    StatusTextContainer: styled.div.attrs({ className: 'status__container' })`
        display: grid;
        grid-template-columns: 70px 1fr;
        grid-column-gap: 35px;

        @media(max-width: 800px){
            grid-template-columns: 1fr;
            justify-content: center;
            align-items: center;
            grid-row-gap: 20px;
            text-align: center;
            br{
                display: none;
            }
        }
    `,
    StatusText: styled.div.attrs({ className: 'status-text__container' })`
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 30px;
        line-height: 110%;
        font-weight: 300;
        color: #282830;
    `,
    StatusSubText: styled.div.attrs({ className: 'status-subtext' })`
        margin-top: 17px;
        margin-bottom: 46px;
        font-family: NobelWGL,Helvetica,Arial,OpenSans,sans-serif;
        font-size: 16px;
        line-height: 237%;
        color: #282830;
        font-weight: 300;
    `,
    GooglePayContainer: styled.p.attrs({ className: 'googlepay__container' })`
        display: grid;
        width: 100%;
        grid-template-columns: 1fr;
        grid-row-gap: 8px;
        margin-bottom: 0;
        margin-top: 0;
        align-items: center;
        justify-content: center;
        & > div{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    `,
    GooglePayText: styled.p.attrs({ className: 'googlepay__text' })`
        font-family: 'Product Sans', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 13px;
        text-align: center;
        color: #808080;
        max-width: 272px;
        margin: 0 auto;
        a{
            text-decoration: underline;
            color: #808080;
        }
    `,
};
